import { ViewModel,View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { CssClassListExtractor } from "src/formBuilder/formBuilder/utilities/cssClassListExtractor";
import { getAsBoolean } from "src/uicomponents/components/utilities";
import  { AddNewPropertyView } from "./addNewProperty-view"

export class AddNewPropertyViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.classSuggestions = CssClassListExtractor.GetClassList();
        this.isClass =  true;
        this.attrValue = '';
        this.attributeValue = '';
        this.eventValue = '';
        this.classValue = '';
        this.htmlValue = '';
    }
    closePopup(result?: any) {
    }
    GetDefaultView(): View <ViewModel> {
        return new AddNewPropertyView();
    }
    public getTypeId(): string {
        return "VM-EC43AD9F-8D5B-4EC7-BCAA-BCCC5EB08DF5"
    }

    public set isAttr(v: boolean) { if(v) {this.unselectAll();} this._isAttr = getAsBoolean(v); } public get isAttr(): boolean { return this._isAttr;} private _isAttr: boolean;
    public set isAttribute(v: boolean) { if(v) {this.unselectAll();}this._isAttribute = getAsBoolean(v); } public get isAttribute(): boolean { return this._isAttribute;} private _isAttribute: boolean;
    public set isEvent(v: boolean) { if(v) {this.unselectAll();} this._isEvent = getAsBoolean(v); } public get isEvent(): boolean { return this._isEvent;} private _isEvent: boolean;
    public set isClass(v: boolean) { if(v) {this.unselectAll();} this._isClass = getAsBoolean(v); } public get isClass(): boolean { return this._isClass;} private _isClass: boolean;
    public set isHtml(v: boolean) { if(v) {this.unselectAll();} this._isHtml = getAsBoolean(v); } public get isHtml(): boolean { return this._isHtml;} private _isHtml: boolean;
    public set attrValue(v: string) { this._attrValue = v; } public get attrValue(): string { return this._attrValue;} private _attrValue: string;
    public set attributeValue(v: string) { this._attributeValue = v; } public get attributeValue(): string { return this._attributeValue;} private _attributeValue: string;
    public set eventValue(v: string) { this._eventValue = v; } public get eventValue(): string { return this._eventValue;} private _eventValue: string;
    public set classValue(v: string) { this._classValue = v; } public get classValue(): string { return this._classValue;} private _classValue: string;
    public set htmlValue(v: string) { this._htmlValue = v; } public get htmlValue(): string { return this._htmlValue;} private _htmlValue: string;
    public set classSuggestions(v: string[]) { this._classSuggestions = v; } public get classSuggestions(): string[] { return this._classSuggestions;} private _classSuggestions: string[];
    
    unselectAll(){
        this.isAttr = false;
        this.isAttribute = false;
        this.isEvent = false;
        this.isClass = false;
        this.isHtml = false;
    }

    confirm(){
        let type = '';
        let resultText = '';
        if(this.isAttr){
            type = 'Attr';
            resultText = `data-b-attr-${this.attrValue}`;
        }else if(this.isAttribute){
            type = 'Attribute';
            resultText = `data-b-attribute-${this.attributeValue}`;
        }else if(this.isEvent){
            type = 'Event';
            resultText = `data-b-event-${this.eventValue}`;
        }else if(this.isClass){
            type = 'Class';
            resultText = `data-b-class-${this.classValue}`;
        }else if(this.isHtml){
            type = 'Html';
            resultText = `${this.htmlValue}`;
        }

        if(resultText==''){
            this.close();
        }else{
            this.closePopup({
                type:type,
                propertyName : resultText.trim()
            })
        }
    }
    close(){
        this.closePopup(false);
    }
}
